export const _reservationBenefitCardUISchema = {
  resources: {
    'ui:widget':'checkboxes'
  },
  description: {
    'ui:widget': 'editorWidget',
  },
  confirmationMessage: {
    'ui:widget': 'editorWidget',
  },
  image: {
    'ui:widget': 'imageWidget',
  },
  vat: {
    'ui:enumDisabled': [10, 14, 24],
  },

}
export const _reservationBenefitCardClass = {
  name: { type: 'string', title: 'Sarjakortin nimi' },
  // price: { type: 'number', title: 'Hinta' },
  count: { type: 'number', title: 'Kertojen määrä', default: 10 },
  reservationduration: {
    type: 'number',
    title: 'Varauksen kesto (minuutteina)',
    default: 60,
  },
  description: { type: 'string', title: 'Kuvaus' },
  vat: {
    type: 'number', title: 'ALV',
    oneOf: [
      { const: 0, title: '0%' },
      { const: 10, title: '10%' },
      { const: 13.5, title: '13,5%' },
      { const: 14, title: '14%' },
      { const: 24, title: '24%' },
      { const: 25.5, title: '25,5%' },
    ]
  },
  accounting: { type: 'string', title: 'Kirjanpidontili' },
  variations: {
    title: '',
    description: 'Hintavaihtoehdot',
    type: 'array',
    items: {
      type: 'object',
      properties: {
        name: { type: 'string', title: 'Nimi' },
        price: { type: 'number', title: 'Hinta' },
        productCode: { type: 'string', title: 'Tuotekoodi' },
      },
    },
  },
  // validuntil: { type: 'string', format: 'date', title: 'Voimassaolon viimeinen päivä' },
  availableinshop: {
    type: 'string',
    title: 'Näytetäänkö verkkokaupassa',
    oneOf: [
      { const: 'true', title: 'Kyllä' },
      { const: 'false', title: 'Ei' },
    ],
    default: 'false',
  },
  // sport: {
  //   type: 'string',
  //   title: 'Laji',
  //   enum: [],
  //   enumNames: [],
  // },
  resources: {
    type: 'array',
    title: 'Resurssit',
    items: {
      type: 'string',
      oneOf: [],
    },
    uniqueItems: true,
  },
  limits: {
    type: 'object',
    title: 'Rajoitukset',
    properties: {
      maxperday: { type: 'number', title: 'Käyttökertojen maksimimäärä päivässä' },
      maxperweek: { type: 'number', title: 'Käyttökertojen maksimimäärä viikossa' },
      maxpermonth: { type: 'number', title: 'Käyttökertojen maksimimäärä kuukaudessa' },
    },
  },
  quota: {
    type: 'number',
    title: 'Yhtäaikaisvarauksien määrä',
    default: 0,
  },
  tag: {
    type: 'string',
    title: 'Varauksen tunniste',
  },
  validity: {
    type: 'string',
    title: 'Voimassaoloaika',
    oneOf: [
      { const: 'rolling', title: 'Rullaava ajanjakso' },
      { const: 'next', title: 'Seuraavaan ajanjaksoon' },
      { const: 'fixed', title: 'Kiinteä ajanjakso' },
      { const: 'permanent', title: 'Pysyvä' },
    ],
  },
  schedule: {
    type: 'string',
    title: 'Voimassaoloaikataulu',
    oneOf: [],
  },
  // validity: {
  //   type: 'string',
  //   title: 'Voimassaoloaika',
  //   enum: ['rolling', 'next', 'fixed', 'permanent'],
  //   enumNames: ['Rullaava ajanjakso', 'Seuraavaan ajanjaksoon', 'Kiinteä ajanjakso', 'Pysyvä'],
  // },

  // type: {
  //   type: 'string',
  //   title: 'Sarjakortin tyyppi',
  //   enum: ['time', 'count'],
  //   enumNames: ['Aikapohjainen', 'Kertapohjainen'],
  // },
}
export const _reservationBenefitCardClassDeps = {
  availableinshop: {
    oneOf: [
      {
        properties: {
          availableinshop: {
            enum: ['true'],
          },
          image: { type: 'string', title: 'Verkkokaupan tuotekuva', items: { type: 'object', images: [] }, minaspectratio: 1 },
          confirmationSubject: { type: 'string', title: 'Vahvistusviestin otsikko' },
          confirmationMessage: { type: 'string', title: 'Vahvistusviestin sisältö' },
          // validityperiod: {
          //   type: 'number',
          //   title: 'Voimassaoloaika päivinä ostohetkestä (0 = ei päättymistä)',
          // },
          // validfrom: {
          //   type: 'string',
          //   title: 'Voimassaolo alkaa, jätä tyhjäksi jos alkaa ostohetkestä',
          //   format: 'date',
          // },
          // validuntil: {
          //   type: 'string',
          //   title: 'Voimassaolo päättyy, jos voimassa oloaika on asetettu se kumpi on aiemmin määrää',
          //   format: 'date',
          // },
        }
      },
      {
        properties: {
          availableinshop: {
            enum: ['false'],
          },
        }
      }
    ]
  },
  validity: {
    oneOf: [
      {
        properties: {
          validity: {
            enum: ['rolling'],
          },
          unit: {
            type: 'string',
            title: 'Rullaava ajanjakso',
            oneOf: [
              { const: 'day', title: 'Päivä' },
              { const: 'week', title: 'Viikko' },
              { const: 'month', title: 'Kuukausi' },
              { const: 'year', title: 'Vuosi' },
            ],
          },
          amount: {
            type: 'number',
            title: 'Montako ajanjaksoa ostohetkestä',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['next'],
          },
          endof: {
            type: 'string',
            title: 'Päättyy',
            oneOf: [
              { const: 'month', title: 'Kuukauden lopussa' },
              { const: 'year', title: 'Vuoden lopussa' },
            ],
          },
          daysahead: {
            type: 'number',
            title: 'Montako päivää ennen aletaan myydä seuraavaa ajanjaksoa. 0 = tästä hetkestä kuluvan ajanjakson loppuun asti.',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['fixed'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
          lastvalid: {
            type: 'string',
            title: 'Viimeinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
      {
        properties: {
          validity: {
            enum: ['permanent'],
          },
          firstvalid: {
            type: 'string',
            title: 'Ensimmäinen voimassaolopäivä',
            format: 'date',
          },
        },
      },
    ],
  },

}
